




















import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export default class BaseModal extends Vue {
  @Prop({default: false}) isBank: boolean
  @Prop({default: false}) isSign: boolean
}
